<template>
  <div class="full-page-width view-shipment">
    <div class="add-button c-float m-b-25">
      <div class="flex-center float-left">
        <Btn
          @click.native="routeIt"
          class="light bordered empty d-inline-block m-r-15 fix-40"
          :icon="{
            name: 'arrowLeftBig',
            size: '20',
          }" />
        <p class="user-name" v-if="get_single_shipment !== null">{{ `${$t('shipment')} #${get_single_shipment.id}` }}</p>
      </div>
      <Dropdown
        class="float-right drop-right"
        :buttonText="$t('Actions')"
        :dropdownOptions="availableDropdownOptions"
        @optionSelected="optionSelected" />
    </div>
    <!-- TOP BAR -->
    <div v-if="get_single_shipment !== null">
      <div class="shipment-info-box card no-pad m-b-40">
        <div class="map-holder">
          <GmapMap
            ref="mapRef"
            :center="center"
            :path="path"
            :zoom="10"
            :options="{
              zoomControl: false,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false
            }"
            style="width: 100%; height: 500px">
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers.reverse()"
              :label="{text: markerLabels[index++ % markerLabels.length]}"
              :position="m"
              :clickable="false"
              :draggable="false"
              @click="center=m.position"
            />
          </GmapMap>
        </div>
        <div class="top-row flex">
          <div class="info-box fix-width-position">
            <p class="small-text">{{ formatDate(get_single_shipment.ship_date, 'shipment') }}</p>
            <p class="big-text">
              <span class="cut-text medium">{{ get_single_shipment.sender_city }}</span>
              <span class="align-middle">{{ `, ${get_single_shipment.sender_country_alpha2}` }}</span>
            </p>
            <p class="small-text tooltip-holder">
              <span class="cut-text small">{{ get_single_shipment.sender_company_name ||  get_single_shipment.sender_name}}</span>
              <span class="d-inline-block info-tooltip">
                <Icon
                  v-tooltip="{ ref: 'tooltipRef'}"
                  name="info"
                  size="15" />
                <div class="info-tooltip-window" ref="tooltipRef">
                  <p v-if="get_single_shipment.sender_company_name">{{ get_single_shipment.sender_company_name }}</p>
                  <p v-if="get_single_shipment.sender_name">{{ get_single_shipment.sender_name }}</p>
                  <p v-if="get_single_shipment.sender_address_1">{{ get_single_shipment.sender_address_1 }}</p>
                  <p v-if="get_single_shipment.sender_address_2">{{ get_single_shipment.sender_address_2 }}</p>
                  <p v-if="get_single_shipment.sender_post_code || get_single_shipment.sender_city">{{ `${get_single_shipment.sender_post_code} ${get_single_shipment.sender_city}` }}</p>
                  <p v-if="get_single_shipment.sender_state">{{ get_single_shipment.sender_state }}</p>
                  <p v-if="get_single_shipment.sender_country_id">{{ countryName(get_single_shipment.sender_country_id) }}</p>
                  <p v-if="get_single_shipment.sender_phone">{{ `${get_single_shipment.sender_phone}` }}</p>
                  <p v-if="get_single_shipment.sender_email">{{ get_single_shipment.sender_email }}</p>
                </div>
              </span>
            </p>
          </div>
          <div class="middle-box status-box" v-if="get_single_shipment != null">
            <div
              class="shipment-status-bar"
              :class="statusInfo(get_single_shipment.status).class">
              <svg class="stroke-dashed" xmlns="http://www.w3.org/2000/svg">
                <line x1="0" y1="0" x2="100%" y2="0" />
              </svg>
              <div class="icon-point">
                <p class="status-text">{{ $t(statusInfo(get_single_shipment.status).text) }}</p>
                <Icon
                  :name="statusInfo(get_single_shipment.status).icon"
                  size="15" />
              </div>
              <div class="point-one"></div>
              <div class="point-two"></div>
            </div>
            <p class="update-info">
              {{ `${$t('last_update')}` }} <span style="text-transform: lowercase">{{ `${formatDate(get_single_shipment.shipment_status_date, 'shipment_last_update')}` }} </span> |
              {{ getStatusMessageText(get_single_shipment.shipment_status_message) }}
            </p>
          </div>
          <div class="info-box fix-width-position">
            <p class="small-text">{{ formatDate(get_single_shipment.eta, 'shipment') }}</p>
            <p class="big-text">
              <span class="cut-text medium">{{ get_single_shipment.customer_address_city }}</span>
              <span class="align-middle">{{ `, ${get_single_shipment.customer_address_country_alpha2}` }}</span>
            </p>
            <p class="small-text tooltip-holder">
              <span class="cut-text small">{{ get_single_shipment.customer_address_company_name ||  get_single_shipment.customer_address_name}}</span>
              <span class="d-inline-block info-tooltip">
                <Icon
                  v-tooltip="{ ref: 'tooltipRefCustomer'}"
                  name="info"
                  size="15" />
                <div class="info-tooltip-window" ref="tooltipRefCustomer">
                  <p v-if="get_single_shipment.customer_address_company_name">{{ get_single_shipment.customer_address_company_name }}</p>
                  <p v-if="get_single_shipment.customer_address_name">{{ get_single_shipment.customer_address_name }}</p>
                  <p v-if="get_single_shipment.customer_address_address_1">{{ get_single_shipment.customer_address_address_1 }}</p>
                  <p v-if="get_single_shipment.customer_address_address_2">{{ get_single_shipment.customer_address_address_2 }}</p>
                  <p v-if="get_single_shipment.customer_address_post_code || get_single_shipment.customer_address_city">{{ `${get_single_shipment.customer_address_post_code} ${get_single_shipment.customer_address_city}` }}</p>
                  <p v-if="get_single_shipment.customer_address_state">{{ get_single_shipment.customer_address_state }}</p>
                  <p v-if="get_single_shipment.customer_address_country_id">{{ countryName(get_single_shipment.customer_address_country_id) }}</p>
                  <p v-if="get_single_shipment.customer_address_phone">{{ `${get_single_shipment.customer_address_phone}` }}</p>
                  <p v-if="get_single_shipment.customer_address_email">{{ get_single_shipment.customer_address_email }}</p>
                </div>
              </span>
            </p>
          </div>
        </div>
        <div class="separator medium"></div>
        <div class="bottom-row flex">
          <div class="info-box c-float w-33">
            <LogosSVG :name="get_single_shipment.shipping_agent_name" size="45" class="float-left m-r-15" />
            <div class="float-left">
              <div v-if="!get_single_shipment.internal_tracking_link && !get_single_shipment.tracking_link">
                <p class="big-info-text">
                  <span class="m-r-5">{{ get_single_shipment.trace_no }}</span>
                </p>
              </div>
              <div v-else>
                <p class="big-info-text pointer" @click.stop="linkCall(get_single_shipment.internal_tracking_link ? get_single_shipment.internal_tracking_link : get_single_shipment.tracking_link)">
                  <span class="m-r-5 color-brend">{{ get_single_shipment.trace_no }}</span>
                  <Icon
                    class="d-inline-block align-middle color-brand"
                    name="link"
                    size="14" />
                </p>
              </div>
              <div>
                <p class="small-text tooltip-holder">
                  <span class="cut-text small">{{get_single_shipment.shipping_agent_name}}</span>
                  <span class="d-inline-block info-tooltip">
                <Icon
                  v-tooltip="{ ref: 'tooltipCustomerService'}"
                  name="info"
                  size="15" />
                <div class="info-tooltip-window" ref="tooltipCustomerService">
                  <p>{{ `${$t('customer_service')}` }}</p>
                  <p>{{ get_single_shipment.agent.email }}</p>
                  <p>{{ get_single_shipment.agent.phone }}</p>
                </div>
                </span>
                </p>
              </div>
            </div>
          </div>
          <div class="middle-box c-float w-33">
            <Icon
              :circle=true
              name="hashMark"
              size="17"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ `${$t('Sender ref.:')} ${get_single_shipment.sender_reference || '-'}` }}</p>
              <p class="small-info-text">{{ `${$t('Receiver ref.:')} ${get_single_shipment.receiver_reference || '-'}` }}</p>
            </div>
          </div>
          <div class="info-box c-float fix-width-position w-33 max-w-225">
            <Icon
              :circle=true
              :name="goodTypeName(get_single_shipment.goods_type_prioritized).icon"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ get_single_shipment.shipping_product_name }}</p>
              <p class="small-info-text">{{ getShipmentGoodsTypeText(get_single_shipment) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- LEFT PART - PRODUCTS -->
    <div class="row text-box">
      <div class="col-xs-8" v-if="get_single_shipment != null">
        <!-- DOCUMENTS -->
        <div class="m-b-40">
          <h2 class="m-b-20 section-title">{{ $t('documents') }}</h2>
          <div class="package-preview card-boxed">
            <div class="flex-boxed center">
              <!-- 1. Waybill -->
              <div class="info-box inf-abs c-float">
                <Icon
                  :circle=true
                  name="barcode"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ $t('Waybills') }}</p>
                  <p class="small-info-text link pointer" @click="downloadWaybill">
                    {{ $t('Download waybills') }}
                  </p>
                  <a
                    style="display: none"
                    :download="`Waybill_${get_single_shipment.id}`"
                    ref="downloadWaybillPDF"
                    :href="waybillPdfPath" />
                </div>
              </div>
              <!-- 2. EOD -->
              <div class="info-box inf-abs c-float" v-if="get_single_shipment.batch_number != null">
                <Icon
                  :circle=true
                  name="agreements"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ $t('eod_manifest') }}</p>
                  <p class="small-info-text link pointer" @click="downloadEOD">
                    {{ $t('Download EOD') }}
                  </p>
                </div>
              </div>
              <a
                style="display: none"
                :download="`${downloadEodName}`"
                ref="downloadEODPDF"
                :href="eodPdfPath" />
              <!-- 3. POD -->
              <div class="info-box inf-abs c-float" v-if="shouldShowDownloadSignatureLink">
                <Icon
                  :circle=true
                  name="edit"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ $t('POD signature') }}</p>
                  <p class="small-info-text link pointer" @click="downloadPOD">
                    {{ $t('Download signature') }}
                  </p>
                  <a
                    style="display: none"
                    :download="`Signature_images_${get_single_shipment.id}`"
                    ref="downloadPODref"
                    :href="podPath" />
                </div>
              </div>
              <!-- 4. POD images -->
              <div class="info-box inf-abs c-float" v-if="get_single_shipment.scan_image_paths != null && get_single_shipment.scan_image_paths != ''">
                <Icon
                  :circle=true
                  name="images"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ $t('POD images') }}</p>
                  <p class="small-info-text link pointer" @click="downloadScanImage">
                    {{ $t('Download images') }}
                  </p>
                  <a
                    style="display: none"
                    :download="`POD_images_${get_single_shipment.id}`"
                    ref="downloadScanImage"
                    :href="scanImagePath" />
                </div>
              </div>
              <!-- 5. Commercial invoice -->
              <div class="info-box inf-abs c-float" v-if="get_single_shipment.customs_file != null">
                <Icon
                  :circle=true
                  name="agreements"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ $t('invoice') }}</p>
                  <p class="small-info-text link pointer" @click="downloadInvoice">
                    {{ $t('Download invoice') }}
                  </p>
                  <a
                    style="display: none"
                    :download="`Invoice_${get_single_shipment.id}`"
                    ref="downloadInvoicePDF"
                    :href="invoicePdfPath" />
                </div>
              </div>
              <!-- 6. dg -->
              <div class="info-box inf-abs c-float" v-if="get_single_shipment.dg_file != null">
                <Icon
                  :circle=true
                  name="agreements"
                  size="20"
                  class="icon-left m-r-15" />
                <div class="float-left">
                  <p class="big-info-text">{{ $t('dangerous_goods') }}</p>
                  <p class="small-info-text link pointer" @click="downloadDGFile">
                    {{ $t('download_dangerous_goods') }}
                  </p>
                  <a
                    style="display: none"
                    :download="`dg_${get_single_shipment.id}`"
                    ref="downloadDgRef"
                    :href="dangerousGoodsPdfPath" />
                </div>
              </div>
              <!-- 7. Additional files -->
              <div
                v-for="(file, index) in get_single_shipment.additional_files"
                :key="`${index}-file`"
                class="info-box inf-abs c-float">
                <Icon
                  :circle=true
                  name="attach"
                  size="20"
                  class="icon-left m-r-15"/>
                <div class="float-left">
                  <p class="big-info-text">{{ get_additional_file_types[index] }}</p>
                  <p class="small-info-text link pointer" @click="downloadAdditionalFile(index)">
                    {{ file.file_name }}
                  </p>
                  <a
                    style="display: none"
                    :download="`${file.file_name}`"
                    :ref="`downloadAdditionalFile${index}`"
                    :href="additionalFilePdfPath[index]"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- PACKAGES -->
        <div>
          <div
            v-for="(item, index) in get_single_shipment.packages" :key="`package-${index}`">
            <template v-if="item.package_trace_no !== null">
              <h2 class="m-b-20 section-title">{{ `#${index+1}: ${packageName(item)} - ${item.package_trace_no}` }}</h2>
            </template>
            <template v-else>
              <h2 class="m-b-20 section-title">{{ `#${index+1}: ${packageName(item)}` }}</h2>
            </template>
            <div
              :class="index + 1 < get_single_shipment.packages.length ? 'm-b-40' : ''"
              class="package-preview card m-b-40">

              <!-- MAIN INFO -->
              <div class="flex center" style="align-items: start;">
                <!-- Package name -->
                <div
                  :class="item.services.length > 0 || item.has_temperature ? '' : 'w-50'"
                  class="info-box c-float">
                  <Icon
                    :circle=true
                    :name="goodTypeName(item.goods_type).icon"
                    size="20"
                    class="float-left m-r-15" />
                  <div class="float-left">
                    <p class="big-info-text">{{ $t(item.packaging_name) }}</p>
                    <p class="small-info-text">
                      {{ `${item.length} x ${item.height} x ${item.width} cm (${getVolumeText(item.vol_dm3)}` }}
                      <span style="vertical-align: super;
                        font-size: 10px;
                        line-height: 0px;">3</span>
                      )
                    </p>
                  </div>
                </div>
                <!-- Package weight -->
                <div
                  :class="item.services.length > 0 || item.has_temperature ? '' : 'w-50'"
                  class="info-box c-float">
                  <Icon
                    :circle=true
                    name="scale"
                    size="20"
                    class="float-left m-r-15" />
                  <div class="float-left">
                    <p class="big-info-text">{{ item.weight | weight }}</p>
                    <p class="small-info-text">Volume {{ item.volume_in_kg | weight }}</p>
                  </div>
                </div>
                <!-- Package dangerous goods -->
                <div class="info-box c-float" v-if="get_shipment_dangerous_goods(item.shipment_package_group_id) && get_shipment_dangerous_goods(item.shipment_package_group_id).dangerous_goods.length > 0">
                  <Icon
                    :circle=true
                    name="energy"
                    size="20"
                    class="float-left m-r-15" />
                  <div class="float-left">
                    <p class="big-info-text">Dangerous goods</p>
                    <div v-for="(groupDg, index) in get_shipment_dangerous_goods(item.shipment_package_group_id).dangerous_goods" :key="`dg-service-${index}`">
                      <p class="small-info-text cut-text extra-small">{{ `${groupDg.dangerous_goods.shipment_view_name}` }}</p>
                    </div>
                  </div>
                </div>
                <!-- Package temperature -->
                <div class="info-box c-float" v-if="item.has_temperature">
                  <Icon
                    :circle=true
                    name="temperature"
                    size="20"
                    class="float-left m-r-15" />
                  <div class="float-left">
                    <p class="big-info-text">{{ $t('Temperature controlled') }}</p>
                    <p class="small-info-text">{{ `${item.min_temp} ${$t('to')} ${item.max_temp}` }} C&deg;</p>
                  </div>
                </div>
              </div>
              <div class="separator"></div>
              <!-- CONTENT INFO -->
              <div v-if="item.content.length > 0">
                <h2 class="m-b-20 f-s-16 f-w-500">{{ $t('content').toUpperCase() }}</h2>
                <div
                  class="content-item flex center top"
                  :class="index + 1 < item.content.length ? 'm-b-15' : ''"
                  v-for="(content, index) in item.content" :key="`package-${index}`">
                  <div>
                    <p class="big-info-text">{{ content.description }}</p>
                    <p class="small-info-text" v-if="content.hs_code && content.origin_country_id">
                      {{ `${$t('HS code')}: ${content.hs_code} - ${$t('Origin')}: ${getCountry(content.origin_country_id, 'name')} (${content.origin_country_alpha2})` }}
                    </p>
                  </div>
                  <div class="big-info-text">
                    {{`${content.quantity}  x `}}
                    {{ content.unit_value | forNum }} {{ content.unit_value_currency.toUpperCase() }}
                  </div>
                  <div class="big-info-text">
                    {{ content.quantity * content.unit_value | forNum }} {{ content.unit_value_currency.toUpperCase() }}
                  </div>
                </div>
              </div>
              <div v-else>
                <h2 class="m-b-20 f-s-16 f-w-500">{{ $t('content').toUpperCase() }}</h2>
                <div
                  class="content-item flex center top">
                  <div>
                    <p class="big-info-text">{{ item.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- FINANCE -->
        <div>
          <h2 class="m-b-20 section-title">{{ $t('Finance') }}</h2>
          <div class="card">
            <div v-for="[awb, financeGroup] in financeGrouped" :key="`${awb}-finance`">
              <p class="finance-header-text" v-if="shipmentIsCalculatedByColli">{{ `AWB - ${awb}` }}</p>
              <div class="finance-card">
                <div class="finance-index">
                  <p class="f-col-1">{{ $t('Booked') }}</p>
                  <p class="f-col-2">{{ $t('invoiced') }}</p>
                  <p v-if="get_is_ship365" class="f-col-3">{{ $t('Invoice controle') }}</p>
                </div>
                <div class="finance-row">
                  <div class="info-box c-float f-col-1">
                    <Icon
                      :circle=true
                      name="scale"
                      size="20"
                      class="float-left m-r-15"/>
                    <div class="float-left">
                      <p class="big-info-text">{{ getFinanceBillingWeight(awb) | weight }}</p>
                      <p class="small-info-text">{{ $t('Bill weight') }}</p>
                    </div>
                  </div>
                  <div class="info-box c-float f-col-2">
                    <div class="float-right">
                      <p class="big-info-text">-</p>
                      <p class="small-info-text">-</p>
                    </div>
                  </div>
                  <div v-if="get_is_ship365" class="info-box c-float f-col-3">
                    <div class="float-right">
                      <p class="big-info-text">-</p>
                      <p class="small-info-text">-</p>
                    </div>
                  </div>
                </div>
                <div class="finance-row" v-for="(item, itemIndex) in financeGroup" :key="`${itemIndex}-colli`">
                  <div class="info-box c-float f-col-1">
                    <Icon
                      :circle=true
                      :name="iconType(item.type)"
                      size="20"
                      class="float-left m-r-15"/>
                    <div class="float-left">
                      <p class="big-info-text">{{ item.booked_price | currency }}</p>
                      <p class="small-info-text">{{ $t(item.item_name) }}</p>
                    </div>
                  </div>
                  <div class="info-box c-float f-col-2">
                    <div class="float-right">
                      <p class="big-info-text">-</p>
                      <p class="small-info-text">-</p>
                    </div>
                  </div>
                  <div v-if="get_is_ship365" class="info-box c-float f-col-3">
                    <div class="float-right">
                      <p class="big-info-text">-</p>
                      <p class="small-info-text">-</p>
                    </div>
                  </div>
                </div>
                <div class="finance-row" v-if="showVat">
                  <div class="info-box c-float f-col-1">
                    <Icon
                      :circle=true
                      :name="iconType('vat')"
                      size="18"
                      class="float-left m-r-15"/>
                    <div class="float-left">
                      <p class="big-info-text">{{ vatAmountGrouped.get(awb) | currency }}</p>
                      <p class="small-info-text">{{ `${$t('VAT')} (${get_active_subaccount.vat_percent}%)` }}</p>
                    </div>
                  </div>
                  <div class="info-box c-float f-col-2">
                    <div class="float-right">
                      <p class="big-info-text">-</p>
                      <p class="small-info-text">-</p>
                    </div>
                  </div>
                  <div v-if="get_is_ship365" class="info-box c-float f-col-3">
                    <div class="float-right">
                      <p class="big-info-text">-</p>
                      <p class="small-info-text">-</p>
                    </div>
                  </div>
                </div>
                <div class="separator small"></div>
                <div class="finance-row">
                  <div class="info-box c-float f-col-1">
                    <Icon
                      :circle=true
                      :name="iconType('sum')"
                      size="28"
                      class="float-left m-r-15"/>
                    <div class="float-left">
                      <p class="big-info-text">{{ totalAmountGrouped.get(awb) | currency }}</p>
                      <p class="small-info-text">{{ $t('total') }}</p>
                    </div>
                  </div>
                  <div class="info-box c-float f-col-2">
                    <div class="float-right">
                      <p class="big-info-text">-</p>
                      <p class="small-info-text">-</p>
                    </div>
                  </div>
                  <div v-if="get_is_ship365" class="info-box c-float f-col-3">
                    <div class="float-right">
                      <p class="big-info-text">-</p>
                      <p class="small-info-text">-</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- DETAILS -->
      <div class="col-xs-4" v-if="get_single_shipment != null">
        <h2 class="m-b-20 section-title">{{ $t('details') }}</h2>
        <div class="card details-box m-b-40">
          <div class="info-box c-float" v-if="get_single_shipment.prg_number">
            <Icon
              :circle=true
              name="document"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ $t('pickup_number' )}}</p>
              <p class="small-info-text">{{ get_single_shipment.prg_number }}</p>
            </div>
          </div>
          <div class="info-box c-float">
            <Icon
              :circle=true
              name="building"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ $t('account') }}</p>
              <p class="small-info-text">{{ getAccountName }}</p>
            </div>
          </div>
          <div class="info-box c-float">
            <Icon
              :circle=true
              name="coins"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ $t('freight_paid_by')}}</p>
              <p class="small-info-text">{{ $t(freightPaidByName) }}</p>
            </div>
          </div>
          <div class="info-box c-float">
            <Icon
              :circle=true
              name="document"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ $t('Incoterms')}}</p>
              <p class="small-info-text">{{ get_single_shipment.goods_incoterm }}</p>
            </div>
          </div>
          <div
            class="info-box c-float"
            v-if="get_single_shipment.pickup_time_from != '' && get_single_shipment.pickup_time_from != null && get_single_shipment.pickup_time_from != undefined">
            <Icon
              :circle=true
              name="deliveryTime"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">
                {{ $t('pickup') }} {{ `${get_single_shipment.pickup_time_from} - ${get_single_shipment.pickup_time_until}` }}
              </p>
              <p class="small-info-text">{{ get_single_shipment.pickup_driver_note }}</p>
            </div>
          </div>
          <div v-if="get_single_shipment !== null">
            <div
              v-for="(item, index) in get_single_shipment.fees" :key="`item-${index}`"
              class="info-box c-float">
              <Icon
                :circle=true
                name="truck"
                size="20"
                class="float-left m-r-15" />
              <div class="float-left">
                <p class="big-info-text">{{ item.name }}</p>
                <p class="small-info-text" v-if="parseInt(item.wrapper_category) === 9">
                  {{ get_single_shipment.active_services_view[item.fee_wrapper_id].value }}
                  {{ get_single_shipment.active_services_view[item.fee_wrapper_id].currency }}
                </p>
                <p class="small-info-text" v-if="parseInt(item.wrapper_category) === 26">
                  {{ formatDate(get_single_shipment.active_services_view[item.fee_wrapper_id].date) }} -
                  {{ get_single_shipment.active_services_view[item.fee_wrapper_id].time }}
                </p>
                <p class="small-info-text" v-if="parseInt(item.wrapper_category) === 24">
                  {{ get_single_shipment.active_services_view[item.fee_wrapper_id].details }}
                </p>
                <p class="small-info-text" v-if="parseInt(item.wrapper_category) === 8">
                  {{ formatDate(get_single_shipment.active_services_view[item.fee_wrapper_id].date) }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="get_single_shipment !== null">
            <div
              v-for="(item, index) in get_single_shipment.custom_tags" :key="`item-${index}`"
              class="info-box c-float">
              <Icon
                :circle=true
                name="tag"
                size="20"
                class="float-left m-r-15" />
              <div class="float-left">
                <p class="big-info-text">{{ item.custom_tag_name }}</p>
                <p class="small-info-text" style="word-break: break-word;">{{ item.custom_tag_value }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- TIMELINE -->
        <h2 class="m-b-20 section-title">{{ $t('timeline') }}</h2>
        <div class="card details-box">
          <div v-if="get_single_shipment !== null" class="timeline-box">
            <svg class="stroke-dashed" xmlns="http://www.w3.org/2000/svg">
              <line x1="0px" y1="40px" x2="0px" y2="100%" />
            </svg>
            <div class="timeline-holder">
              <div
                v-for="(group, index) in timelineArray" :key="`group-${index}`"
                class="timeline-group">
                <div class="list-separator"><div></div></div>
                <h2 class="timeline-group-title">{{ index }}</h2>
                <div class="timeline-info">
                  <div v-for="(item, index) in group" :key="`groupItem-${index}`" class="info-box c-float">
                    <div v-if="item.status_id == 24 ||
                      item.status_id == 25 ||
                      item.status_id == 26 ||
                      item.status_id == 27 ||
                      item.status_id == 28 ||
                      item.status_id == 29 ||
                      item.status_id == 30 ||
                      item.status_id == 31 ||
                      item.status_id == 33 ||
                      item.status_id == 37 ||
                      item.status_id == 40 ||
                      item.status_id == 41">
                      <Icon
                        :circle=true
                        :name="statusInfo(item.status_id).icon"
                        size="20"
                        class="float-left m-r-15" />
                      <div class="float-left" style="width: 100%;">
                        <p class="big-info-text">{{ `${item.created_time} | ${getStatusMessageText(item.message) || $t(statusInfo(item.status_id).text)}` }}</p>
                        <p v-if="item.addition != null || item.addition != undefined"
                          class="small-info-text" style="word-break: break-word;">{{ item.addition.split(",").join(", ") }}</p>
                      </div>
                    </div>
                    <div v-else-if="[44,45].includes(parseInt(item.status_id))">
                      <Icon
                        :circle=true
                        name="truck"
                        size="20"
                        class="float-left m-r-15" />
                      <div class="float-left" style="width: 100%;">
                        <p class="big-info-text">{{ `${item.created_time} | ${getStatusMessageText(item.message, '#', 0)}` }} <a class="pointer link small-info-text" @click="$router.push(`/pickups/booked/${getStatusMessageText(item.message, '#', 1)}`)">#{{ getStatusMessageText(item.message, '#', 1) }}</a></p>
                        <p class="small-info-text" style="word-break: break-word;">{{ item.addition }}</p>
                      </div>
                    </div>
                    <div v-else>
                      <Icon
                        :circle=true
                        :name="statusInfo(item.status_id).icon"
                        :size="item.status_id == 3 ? '24' : '20'"
                        class="float-left m-r-15" />
                      <div class="float-left" style="width: 100%;">
                        <p class="big-info-text" v-if="item.message.startsWith('CREATED_EOD_STATUS_MESSAGE') && item.message.includes('#')">{{ `${item.created_time} | ${getStatusMessageText(item.message, '#', 0)}` }} <a class="small-info-text pointer link" @click="$router.push(`/shipments/end-of-day/${getStatusMessageText(item.message, '#', 1)}`)">#{{ getStatusMessageText(item.message, '#', 1) }}</a></p>
                        <p class="big-info-text" v-else>{{ `${item.created_time} | ${getStatusMessageText(item.message)}` }}</p>
                        <p class="small-info-text" style="word-break: break-word;">{{ item.addition }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Popup
      v-if="emailPopupOpened"
      :popupSmall=true
      :showConfirmButton=false
      :showSendButton=true
      @cancel="closePopup"
      @confirm="emailWaybills">
      <template v-slot:header>
        <h2>{{ $t('E-mail waybills') }}</h2>
      </template>
      <div>
        <div class="m-b-30">
          <span class="d-block m-b-20">{{ $t('Who should receive waybills?') }}</span>
          <div>
            <div class="m-b-10">
              <Checkbox
                :label="$t('Shipper')"
                v-model="selectedShipper"
                @change="selectedShipper = !selectedShipper" />
            </div>
            <div class="m-b-10">
              <Checkbox
                :label="$t('receiver')"
                v-model="selectedReciever"
                @change="selectedReciever = !selectedReciever" />
            </div>
            <div class="m-b-20">
              <Checkbox
                :label="$t('Other')"
                v-model="selectedOther"
                @change="otherNotification" />
            </div>
            <InputText
              v-if="selectedOther"
              class="d-block"
              placeholder="Enter email"
              :label="$t('Other email notification')"
              v-model="otherMail" />
          </div>
        </div>
        <div>
          <span class="d-block textarea-label">{{ $t('Personal message') }}</span>
          <textarea class="textarea-input" v-model="emailMessage"></textarea>
        </div>
      </div>
    </Popup>
    <Popup
      v-if="uploadFileToAgentPopupOpened"
      :popupSmall=true
      :showConfirmButton=false
      :showSendButton=true
      @cancel="closePopup"
      @confirm="uploadFileToAgent">
      <template v-slot:header>
        <h2>{{ $t('Upload file') }}</h2>
      </template>
      <div>
        <div class="m-b-40">
            <InputSelect
              :label="$t('Additional file type?')"
              v-model="additionalFileType"
              :options="selectOptions(get_additional_file_types)"
              :rules="{required: true}"
            />
        </div>
        <div class="m-b-40">
          <div
            :class="'active brand'"
            class="button-bar"
            @click="addFile">
            <Icon
              class="m-r-20"
              name="cloudUpload"
              :circle="true"
              size="20"/>
            <div class="text-box">
              <input
                @change="newFile"
                type="file"
                ref="invButton"
                style="display:none"/>
              <span class="main-text">{{ $t('Choose file for upload') }}</span>
              <span class="sub-title" v-if="additionalFile !== null">{{ additionalFileName }}</span>
            </div>
          </div>
        </div>
      </div>
    </Popup>
    <Popup
      v-if="selectPrinterPopupOpened"
      minHeight="450px"
      :popupSmall=true
      :confirmText="$t('print')"
      @cancel="closePopup"
      @confirm="printWaybill">
      <template v-slot:header>
        <h2>{{ $t('reprint') }}</h2>
      </template>
      <div>
        <div class="m-b-40">
          <InputSelect
            class="m-b-40"
            :label="$t('printer')"
            v-model="popupPrinterId"
            :options="get_waybill_printers"/>
        </div>
      </div>
    </Popup>
    <Popup v-if="showManualCancelPopup" :showConfirmButton="true" :showCancelButton="false" :confirmText="$t('got_it')" @confirm="closeManualCancelPopup"  @cancel="closeManualCancelPopup">
      <template v-slot:header>
        <h2>{{ $t('shippment_not_cancelled') }}</h2>
      </template>
      <div>
        <message name="warning" :data="data={data:information, type:'custom-message'}" v-for="(information, index) in shippmentManualCancel" :key="`error-${index}`"></message>
      </div>
    </Popup>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import mixins from '@/mixins/mixins.js';
import date from '@/mixins/date';
import Popup from '@/components/global/popup';
import Dropdown from '@/components/global/dropdown';
import Btn from '@/components/elements/buttons';
import LogosSVG from "@/assets/images/logosSVG";
import Checkbox from '@/components/elements/inputs/checkbox.vue';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select';
import i18n from "../../i18n";
import shipment from "../../mixins/shipment";

export default {
  name: 'ViewShipment',
  mixins: [mixins, date],
  components: {
    Btn, LogosSVG, Dropdown, Popup, Checkbox, InputText, InputSelect
  },
  data() {
    return{
      downloadEodName: '',
      shippmentManualCancel: {},
      showManualCancelPopup: false,
      scanImagePath: '',
      podPath: '',
      markerLabels : "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      strokeOptions: {
        strokeColor: '#017a75',
        // strokeColor: '#0088FF',
        strokeWeight: 6,
        strokeOpacity: 0.6
      },
      dropdownOptions: [
        {
          text: this.$t('copy_to_new'),
          subText: this.$t('Create with copied data'),
          icon: 'fileCopies',
          action: 'copy'
        },
        {
          text: this.$t('Create return'),
          subText: this.$t('Create with swaped data'),
          icon: 'reply',
          action: 'return'
        },
        {
          text: this.$t('Create EOD'),
          subText: this.$t('Create end of day'),
          icon: 'delivery',
          action: 'create_eod'
        },
        {
          text: this.$t('Print waybills'),
          subText: this.$t('Print waybills'),
          icon: 'printer',
          action: 'print'
        },
        {
          text: this.$t('Email waybills'),
          subText: this.$t('Email waybills'),
          icon: 'letter',
          action: 'email'
        },
        {
          text: this.$t('cancel'),
          subText: this.$t('Cancel shipment'),
          icon: 'deleteForever',
          action: 'cancel'
        },
        {
          text: this.$t('Upload file'),
          subText: this.$t('Send file to agent'),
          icon: 'cloudUpload',
          action: 'upload'
        },
      ],
      invoicePdfPath: '',
      waybillPdfPath: '',
      dangerousGoodsPdfPath: '',
      additionalFilePdfPath: [],
      eodPdfPath: '',
      waybillsPdfPath: '',
      uploadFileToAgentPopupOpened: false,
      additionalFileType: '',
      selectPrinterPopupOpened: false,
      popupPrinterId: '',
      waybillPrinters: '',
      additionalFileName: '',
      additionalFile: null,
      emailPopupOpened: false,
      selectedShipper: true,
      selectedReciever: false,
      selectedOther: false,
      otherMail: '',
      emailMessage: '',
      waybillEmails: [],
      financeGrouped: new Map(),
      totalAmountGrouped: new Map(),
      vatAmountGrouped: new Map(),
    };
  },
  mounted() {
    this.getComponentData()
  },
  computed: {
    shipment() {
      return shipment
    },
    showVat() {
      return this.get_active_subaccount.is_vat && this.get_active_subaccount.vat_percent;
    },
    shipmentIsCalculatedByColli() {
      return this.get_single_shipment.carrier_product.calculation_type == 2;
    },
    setFinanceData() {
      this.get_single_shipment.finance.forEach((item) => {
        const bookedPrice = item.booked_price;
        const key = this.shipmentIsCalculatedByColli ? item.awb : 1;
        //Group data by awb
        if (!this.financeGrouped.get(key)) {
          this.financeGrouped.set(key, [item]);
        } else {
          this.financeGrouped.get(key).push(item);
        }

        //Set total amounts grouped by awb
        if (!this.totalAmountGrouped.get(key)) {
          this.totalAmountGrouped.set(key, bookedPrice);
        } else {
          const newPrice = this.totalAmountGrouped.get(key) + bookedPrice;
          this.totalAmountGrouped.set(key, newPrice);
        }
      });

      if (this.showVat) {
        this.totalAmountGrouped.forEach((val, key) => {
          const vatAmount = Number(val ? (val / 100 * this.get_active_subaccount.vat_percent) : 0);
          const newTotalPrice = vatAmount + Number(val);
          this.vatAmountGrouped.set(key, vatAmount);
          this.totalAmountGrouped.set(key, newTotalPrice);
        })
      }
    },
    availableDropdownOptions(){
      let dropdownOptions = [];
        this.dropdownOptions.forEach(dropdownOption => {
          if (this.get_single_shipment && this.get_single_shipment.status === 5 && dropdownOption.action === 'cancel') {
            return;
          }
          if (this.get_single_shipment && this.get_single_shipment.batch_number !== null && dropdownOption.action === 'create_eod') {
            return;
          }
          dropdownOptions.push(dropdownOption)
        });

      return dropdownOptions;
    },
    ...mapGetters([
      'get_is_ship365',
      'get_single_shipment',
      'get_parcel_types',
      'get_parcel_type_name',
      'get_subaccounts',
      'get_additional_file_types',
      'get_waybill_printers',
      'get_active_subaccount',
      'get_shipment_dangerous_goods'
    ]),
    markers() {
      return [
        {
          lat: Number(this.get_single_shipment.customer_address_address_1_latitude),
          lng: Number(this.get_single_shipment.customer_address_address_1_longitude),
        },
        {
          lat: Number(this.get_single_shipment.sender_address_1_latitude),
          lng: Number(this.get_single_shipment.sender_address_1_longitude),
        },
      ];
    },
    freightPaidByName() {
      if(this.get_single_shipment.freight_paid_by == 1) {
        return 'Seller';
      } else if(this.get_single_shipment.freight_paid_by == 2) {
        return 'Other';
      } else if(this.get_single_shipment.freight_paid_by == 4) {
        return `Freight payer ID ${this.get_single_shipment.freight_payer_id}`;
      }
    },
    path() {
      return [
        {
          lat: Number(this.get_single_shipment.customer_address_address_1_latitude),
          lng: Number(this.get_single_shipment.customer_address_address_1_longitude),
        },
        {
          lat: Number(this.get_single_shipment.sender_address_1_latitude),
          lng: Number(this.get_single_shipment.sender_address_1_longitude),
        },
      ];
    },
    center() {
      return {
        lat: Number(this.get_single_shipment.sender_address_1_latitude),
        lng: Number(this.get_single_shipment.sender_address_1_longitude),
      };
    },
    shouldShowDownloadSignatureLink() {
      return (this.get_single_shipment.scan_pod_paths != null && this.get_single_shipment.scan_pod_paths != '')
        || (this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'Danske Fragtmænd')
        || (this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'GLS')
        || (this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'Dachser')
        || (this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'FedEx')
        || (this.get_single_shipment.status === 14 && this.get_single_shipment.shipping_agent_name === 'DHL Express')
    },
    getAccountName() {
      let name = '-';
      name = this.get_subaccounts.filter((account) => account.id == this.get_single_shipment.subaccount_id)[0].name;
      return name;
    },
    timelineArray() {
      let timelineArray = {};
      this.get_single_shipment.shipment_statuses.forEach((status) => {
        const createdAtFormatted = this.formatDate(status.created_at, 'ddd D MMM YYYY');

        if(timelineArray[createdAtFormatted] == null){
          timelineArray[createdAtFormatted] = [];
        }
        timelineArray[createdAtFormatted].push(status);
      });

      return timelineArray;
    },
    isCustomCarrier() {
      return !!this.get_single_shipment.custom_carrier_id;
    },
  },
  methods: {
    packageName(shipmentPackage){
      if( shipmentPackage.goods_type == 1){
        return this.$t('parcel');
      } else if (shipmentPackage.goods_type == 2){
        return this.$t('document');
      } else if (shipmentPackage.goods_type == 3){
        return this.$t('pallet');
      } else {
        return this.$t('load');
      }
    },
    getFinanceBillingWeight(awb) {
      //If caclulation is by colli then return colli billing weight otherwise shipment weight
      if (this.shipmentIsCalculatedByColli) {
        const colli = this.get_single_shipment.packages.filter((item) => {
          return item.package_trace_no === awb;
        });
        return colli[0].billing_weight;
      }

      return this.get_single_shipment.billing_weight;
    },
    closeManualCancelPopup() {
      this.showManualCancelPopup = false;
      this.shippmentManualCancel = {};
    },
    getStatusMessageText(message, breakpoint, part) {
      //Translate first index of array
      if (message && message.includes('@separator0@')) {
        const statusMsgArray = message.split('@separator0@');
        return `${this.$t(statusMsgArray[0])} ${statusMsgArray[1]}`;
      }

      if (breakpoint && message.includes(breakpoint)) {
        const statusMsgArray = message.split(breakpoint);
        const translationString = statusMsgArray[part] ? statusMsgArray[part].trim() : '';
        return `${this.$t(translationString)}`;
      }

      return `${this.$t(message)}`
    },
    iconType(type) {
      if(type == 1) return 'truck';
      if(type == 5) return 'document';
      if(type == 6) return 'deliveryTime';
      if(type == 9) return 'fuel';
      if(type == 'vat') return 'vatIcon';
      if(type == 'sum') return 'sumSign';
    },
    statusInfo(statusNumber) {
      if(parseInt(statusNumber) === 34){
        return {
          class: 'step1',
          icon: 'clock',
          text: 'Waiting for approval',
        };
      }
      if(parseInt(statusNumber) === 35){
        return {
          class: 'step1',
          icon: 'checkMan',
          text: 'Approved by carrier',
        };
      }
      if(parseInt(statusNumber) === 3){
        return {
          class: 'step1',
          icon: 'check',
          text: 'Booked',
        };
      } else if (parseInt(statusNumber) === 41) {
        //label printed status
        return {
          class: 'step1',
          icon: 'printer',
          text: 'Booked',
        };
      } else if(parseInt(statusNumber) === 23){
        return {
          class: 'step1',
          icon: 'ban',
          text: 'Waiting for departure',
        };
      } else if(parseInt(statusNumber) === 5) {
        return {
          class: 'step1',
          icon: 'deleteForever',
          text: 'canceled',
        };
      } else if(
        parseInt(statusNumber) === 13 ||
        parseInt(statusNumber) === 17 ||
        parseInt(statusNumber) === 12) {
        return {
          class: 'step2',
          icon: 'delivery',
           text: 'transit',
        };
      }else if(parseInt(statusNumber) === 4) {
        return {
          class: 'step2',
          icon: 'agreements',
          text: 'transit',
        };
      } else if (parseInt(statusNumber) === 15) {
        return {
          class: 'step3-pickup',
          icon: 'pin',
          text: 'In Pickup Point',
        };
      } else if(parseInt(statusNumber) === 8 || parseInt(statusNumber) === 16) {
        return {
          class: 'step3',
          icon: 'warning',
           text: 'Deviation',
        };
      } else if(parseInt(statusNumber) === 14) {
        return {
          class: 'step4',
          icon: 'check',
           text: 'Delivered',
        };
      } else if(parseInt(statusNumber) === 1) {
        return {
          class: 'step4',
          icon: 'check',
           text: 'PENDING',
        };
      } else if(
        parseInt(statusNumber) === 24 ||
        parseInt(statusNumber) === 25 ||
        parseInt(statusNumber) === 26 ||
        parseInt(statusNumber) === 27 ||
        parseInt(statusNumber) === 28 ||
        parseInt(statusNumber) === 29 ||
        parseInt(statusNumber) === 30 ||
        parseInt(statusNumber) === 31 ||
        parseInt(statusNumber) === 33 ||
        parseInt(statusNumber) === 40 ) {
        return {
          class: 'step2',
          icon: 'letter',
          text: 'transit',
        };
      } else if(parseInt(statusNumber) === 32) {
        return {
          class: 'step1',
          icon: 'attach',
          text: 'File upload',
        };
      } else {
        return {
          class: 'step1',
          icon: 'check',
          text: '',
        };
      }
    },
    optionSelected(val, optObject) {
      console.log(optObject.action)
      if(optObject.action === 'copy') {
        // Create NEW SHIPMENT
        let shipmentId = this.$route.params.id;
        this.$store.dispatch('GET_SHIPMENT', shipmentId).then((res) => {
          this.$store.dispatch('SET_EDITING_SHIPMENT', res).then(() => {
            this.$router.push('/shipments/book-shipment');
          });
        });
      }
      if(optObject.action === 'return') {
        // Create NEW SHIPMENT
        let shipmentId = this.$route.params.id;
        this.$store.dispatch('GET_SHIPMENT', shipmentId).then((res) => {
          this.$store.dispatch('SET_EDITING_SHIPMENT', {...res, inverted: true, is_return: true}).then(() => {
            this.$router.push('/shipments/book-shipment');
          });
        });
      }
      if(optObject.action === 'create_eod') {
        // Create EOD
        this.$store.dispatch('CREATE_EOD', this.get_single_shipment.id).then((res) => {
          this.downloadEodName = `EOD_${res.batch_number}`;
          this.$store.dispatch('DOWNLOAD_EOD', res.batch_number).then((res) => {
            this.$nextTick(() => {
              let file = window.URL.createObjectURL(res);
              this.$refs.downloadEODPDF.href = file;
              this.eodPdfPath = file;
              this.$refs.downloadEODPDF.click();
            })
          })
        }).finally(() => this.getComponentData());
      }
      if(optObject.action === 'print') {
        this.selectPrinterPopupOpened = true;
        this.popupPrinterId = this.get_single_shipment.user.label_printer_id

      }
      if(optObject.action === 'email') {
        // Create EOD
        this.emailPopupOpened = true;
      }
      if(optObject.action === 'cancel') {
        // Create EOD
        this.$store.dispatch('CANCEL_SHIPMENT', this.get_single_shipment.id).then( r => {

          const response = r.data.data;
          if (response.failed) {
            for (let shippmentId in response.failed) {
              this.$store.commit('SHOW_NOTIFICATION_BAR', {
                message: response.failed[shippmentId].status,
                type: 'alert-window',
              });
            }
          }
          if (response.success) {
            for (let shippmentId in response.success) {
              if (response.success[shippmentId].status === 'agent_does_not_have_cancel_option') {
                if (!this.shippmentManualCancel[response.success[shippmentId].agent_id]) {
                  const agent = response.success[shippmentId].agent_info;
                  const shippment = this.get_single_shipment;
                  const carrierPhone = agent.phone;//shippment.custom_carrier ? shippment.custom_carrier.customer_service_phone : agent.phone;
                  const carrierEmail = agent.email; //shippment.custom_carrier ? shippment.custom_carrier.customer_service_email :  agent.email;
                  const carrierName = agent.name //shippment.custom_carrier ? shippment.custom_carrier.name : agent.name,

                  if (carrierPhone && carrierEmail) {
                    this.shippmentManualCancel[response.success[shippmentId].agent_id] = i18n.t('shipping_agent_does_not_have_cancel_option_view', {
                      carrier_name: carrierName,
                      carrier_phone: carrierPhone,
                      carrier_email: carrierEmail,
                      trace_no: shippment.trace_no
                    });
                  } else if (carrierPhone) {
                    this.shippmentManualCancel[response.success[shippmentId].agent_id] = i18n.t('shipping_agent_does_not_have_cancel_option_without_email_view', {
                      carrier_name: carrierName,
                      carrier_phone: carrierPhone,
                      trace_no: shippment.trace_no
                    });
                  } else if (carrierEmail) {
                    this.shippmentManualCancel[response.success[shippmentId].agent_id] = i18n.t('shipping_agent_does_not_have_cancel_option_without_phone_view', {
                      carrier_name: carrierName,
                      carrier_email: carrierEmail,
                      trace_no: shippment.trace_no
                    });
                  }

                  // this.shippmentManualCancel[response.success[shippmentId].agent_id] = i18n.t('shipping_agent_does_not_have_cancel_option',
                  //   {
                  //     carrier_name : this.get_single_shipment.custom_carrier ? this.get_single_shipment.custom_carrier.name : agent.name,
                  //     carrier_phone : this.get_single_shipment.agent.phone,
                  //     carrier_email : this.get_single_shipment.agent.email
                  //   }
                  // );
                  this.showManualCancelPopup = true;
                }
              }
            }
          }

        }).finally(() => this.getComponentData());
      }
      if(optObject.action === 'upload') {
        this.uploadFileToAgentPopupOpened = true;
      }
    },
    closePopup() {
      this.emailPopupOpened = false;
      this.uploadFileToAgentPopupOpened = false
      this.selectPrinterPopupOpened = false
    },
    otherNotification() {
      this.selectedOther = !this.selectedOther;
      if(!this.selectedOther) {
        this.otherMail = '';
      }
    },
    printWaybill() {
      this.$store.dispatch('PRINT_LABEL', {shipment_id: this.get_single_shipment.id, printer_id: this.popupPrinterId}).then((res) => {
        this.closePopup()
        this.getComponentData()
      })
    },
    emailWaybills() {
      let mailList = [];
      if(this.selectedShipper) {
        mailList.push(this.get_single_shipment.sender_email)
      }

      if(this.selectedReciever) {
        mailList.push(this.get_single_shipment.customer_address_email)
      }

      this.$store.dispatch('EMAIL_WAYBILLS', {
        emails: this.otherMail.length > 0 ? [...mailList, ...this.otherMail.split(',')] : [...mailList],
        message: this.emailMessage,
        id: this.get_single_shipment.id,
      }).then(() => {
        this.emailPopupOpened = false;
      });
    },
    uploadFileToAgent() {
      let formData = new FormData();
      formData.append('file', this.additionalFile)
      this.$store.dispatch('UPLOAD_ADDITIONAL_FILE', {
        shipment_id: this.get_single_shipment.id,
        type: this.additionalFileType,
        file: formData,
      }).then(() => {
        this.closePopup()
        this.getComponentData()
      });
    },
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: property });
      }
      return options;
    },
    addFile() {
      this.$refs.invButton.click();
    },
    newFile() {
      this.additionalFile = this.$refs.invButton.files[0]
      this.additionalFileName = this.$refs.invButton.files[0].name;
    },
    countryName(id){
      return this.getCountry(id, 'name');
    },
    getShipmentGoodsTypeText(shipment) {
      const goodsTypes = {
        1: 'parcel',
        2: 'document',
        3: 'pallet',
        4: 'load'
      };

      const counts = {
        parcel: 0,
        document: 0,
        pallet: 0,
        load: 0
      };

      shipment.packages.forEach((pack) => {
        const type = goodsTypes[pack.goods_type];
        if (type) {
          counts[type]++;
        }
      });

      return Object.entries(counts)
        .filter(([type, count]) => count > 0)
        .map(([type, count]) => `${count} x ${this.$t(type)}`)
        .join(', ');
    },
    goodTypeName(type) {
      if(parseInt(type) === 1) {
        return {
          name: this.$t('parcel'),
          icon: 'savedItems',
        };
      }
      if(parseInt(type) === 2){
        return {
          name: this.$t('document'),
          icon: 'documentGoods',
        };
      }
      if(parseInt(type) === 3){
        return {
          name: this.$t('pallet'),
          icon: 'pallet',
        };
      }
      if(parseInt(type) === 4){
        return {
          name: this.$t('load'),
          icon: 'delivery',
        };
      }
    },
    linkCall(val) {
      window.open(val, '_blank');
      // this.$store.dispatch('GET_TRACKING_LINK', val).then((res) => {
      //
      // });
    },
    downloadEOD() {
      this.$store.dispatch('DOWNLOAD_EOD', this.get_single_shipment.batch_number).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadEODPDF.href = file;
          this.eodPdfPath = file;
          this.$refs.downloadEODPDF.click();
        })
      })
    },
    downloadInvoice() {
      this.$store.dispatch('GET_CUSTOMS_PDF', this.get_single_shipment.id).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadInvoicePDF.href = file;
          this.invoicePdfPath = file;
          this.$refs.downloadInvoicePDF.click();
        })
      })
    },
    downloadWaybill() {
      this.$store.dispatch('GET_LABEL', this.get_single_shipment.id).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadWaybillPDF.href = file;
          this.waybillPdfPath = file;
          this.$refs.downloadWaybillPDF.click();
        })
      })
    },
    downloadScanImage() {
      this.$store.dispatch('GET_SCAN_IMAGE', this.get_single_shipment.id).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadScanImage.href = file;
          this.scanImagePath = file;
          this.$refs.downloadScanImage.click();
        })
      })
    },
    downloadPOD() {
      this.$store.dispatch('GET_POD', this.get_single_shipment.id)
        .then((res) => {
          this.$nextTick(() => {
            let file = window.URL.createObjectURL(res);
            this.$refs.downloadPODref.href = file;
            this.podPath = file;
            this.$refs.downloadPODref.click();
          })
        }).catch((e) => {
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: 'POD_not_found',
          type: 'alert-window',
        });
      })
    },
    downloadDGFile() {
      this.$store.dispatch('GET_DG_FILE', this.get_single_shipment.id).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadDgRef.href = file;
          this.podPath = file;
          this.$refs.downloadDgRef.click();
        })
      })
    },
    downloadAdditionalFile(type) {
      this.$store.dispatch('GET_ADDITIONAL_FILE', {shipment_id: this.get_single_shipment.id, type: type}).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs[`downloadAdditionalFile${type}`][0].href = file;
          this.additionalFilePdfPath[type] = file;
          this.$refs[`downloadAdditionalFile${type}`][0].click();
        })
      })
    },
    routeIt() {
      this.$router.go(-1);
    },
    async getComponentData() {
      this.$store.dispatch('CLEAR_SHIPMENT');
      this.$store.dispatch('GET_SHIPMENT', this.$route.params.id).then((res) => {
        this.$store.dispatch('STORE_SHIPMENT', res);
        this.$store.dispatch('GET_PARCEL_TYPES');
        this.$store.dispatch('GET_ADDITIONAL_FILE_TYPES', {agent: this.get_single_shipment.agent.id});
        this.$store.dispatch('GET_OPTIONS_FOR_WAYBILL_PRINTERS', {popupPrinterId: this.get_single_shipment.user.label_printer_id});
        this.setFinanceData;
        this.downloadEodName = `EOD_${this.get_single_shipment ? this.get_single_shipment.batch_number : '' }`;
        this.$nextTick(() => {
          this.$refs.mapRef.$mapPromise.then((map) => {
            var markerBounds = new window.google.maps.LatLngBounds();
            markerBounds.extend({lat: Number(this.get_single_shipment.customer_address_address_1_latitude), lng: Number(this.get_single_shipment.customer_address_address_1_longitude)})
            markerBounds.extend({lat: Number(this.get_single_shipment.sender_address_1_latitude), lng: Number(this.get_single_shipment.sender_address_1_longitude)});
            map.fitBounds(markerBounds);
          });
        })
      });
    }
  },
  destroyed() {
    this.$store.dispatch('CLEAR_SHIPMENT');
    this.$store.dispatch('CLEAR_PARCEL_TYPES');
  },
  watch: {
    '$route' () {
      this.getComponentData()
    },
  },
}
</script>
